import React, {useContext, useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    LinearProgress,
    Slide,
    TextField
} from "@material-ui/core";
import {TransitionProps} from "@material-ui/core/transitions";
import {UnidadePageContext} from "@pages/UnidadePage/UnidadePageContext";
import {AuthContext} from "@contexts/AuthContext";
import axios from "axios";
import environment from "@environment";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UnidadeModalSalvarAutoescola = () => {
    const {setModalSalvarAutoescola, modalSalvarAutoescola,buscarPorId} = useContext(UnidadePageContext);
    const {showAlert} = useContext(AuthContext)
    const [meuJson, setMeuJson] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setMeuJson('')
        setModalSalvarAutoescola(false);
    };

    const salvarJson = async () => {
        if (!meuJson?.trim()) {
            showAlert("error", 'Cole o JSON no campo de texto.', 'Erro');
            setLoading(false)
            document.getElementById('json-cadastro')?.focus();
            return;
        }
        setLoading(true)
        try {
            const result = await axios.post<any>(environment.url_api_producao_service + 'api/Site/avaliar2', JSON.parse(meuJson));

            setMeuJson('');
            showAlert("success", 'Unidade cadastrada com sucesso!', 'Sucesso');
            if (result.data?.unidadeId){
               await buscarPorId(result.data?.unidadeId)
            }
            setModalSalvarAutoescola(false);

        } catch (e) {
            console.error(e);
            showAlert("error", 'Erro ao salvar a unidade no sistema.', 'Erro');

        } finally {
            setLoading(false)

        }


    }
    useEffect(() => {
        document.getElementById('json-cadastro')?.focus();

    }, [])
    return (
        <div>

            <Dialog
                open={modalSalvarAutoescola}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => !loading && handleClose()}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">Cadastrar unidade no sistema</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Após a unidade cadastrar os dados, cole o JSON recebido aqui para cadastrar no sistema.
                    </DialogContentText>
                    <TextField
                        multiline={true}
                        margin="dense"
                        id="json-cadastro"
                        label="JSON recebido por e-mail"
                        type="text"
                        fullWidth
                        value={meuJson}
                        autoComplete="new-password"
                        disabled={loading}
                        autoFocus
                        onChange={(e) => setMeuJson(e.target.value)}
                    />
                    {loading && <LinearProgress style={{marginTop: 20}}/>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={loading} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={salvarJson} disabled={loading} color="primary">
                        Enviar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default UnidadeModalSalvarAutoescola;
